import type { Feature } from '../services/auth/permissions';

export type QuickCreateKind =
  | 'dossier'
  | 'task'
  | 'audience'
  | 'appointment'
  | 'contact'
  | 'timeEntry'
  | 'invoice';

export interface QuickCreateTile {
  kind: QuickCreateKind;
  label: string;
  /** Basename under /icons/*.svg (Font Awesome regular, design.html). */
  icon: string;
  feature: Feature;
}

export const QUICK_CREATE_TILES: readonly QuickCreateTile[] = [
  { kind: 'dossier', label: 'Dossier', icon: 'folder-open', feature: 'dossiers_create' },
  { kind: 'task', label: 'Tâches', icon: 'list-check', feature: 'tasks_create' },
  { kind: 'audience', label: 'Audience', icon: 'calendar-star', feature: 'hearings_create' },
  { kind: 'appointment', label: 'Rendez-vous', icon: 'calendar-users', feature: 'appointments_manage' },
  { kind: 'contact', label: 'Répertoire', icon: 'users', feature: 'contacts_edit' },
  { kind: 'timeEntry', label: 'Temps', icon: 'stopwatch', feature: 'time_entries_create' },
];

const DOSSIER_ID_RE =
  /^\/dossiers\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

export function filterQuickCreateTiles(
  allowed: Partial<Record<QuickCreateKind, boolean>>,
): QuickCreateTile[] {
  return QUICK_CREATE_TILES.filter((tile) => allowed[tile.kind] === true);
}

export function parseDossierIdFromPath(pathname: string): string | null {
  const match = DOSSIER_ID_RE.exec(pathname);
  return match?.[1] ?? null;
}

export function audienceNeedsReplace(existingIso: string | null | undefined): boolean {
  return typeof existingIso === 'string' && existingIso.length > 0;
}
